import React from 'react';
import PropTypes from 'prop-types';
import { Route, Redirect } from 'react-router-dom';

import storage from '../storage';
import { getCurrentPageAsSearchParam } from '../utils';

const isAuthenticated =
  storage.getItem('token') !== undefined &&
  storage.getItem('token') &&
  storage.getItem('token') !== ''
    ? true
    : false;

const DefaultRoute = ({ component: Component, ...restProps }) => {
  const page = getCurrentPageAsSearchParam();

  return (
    <Route
      {...restProps}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect to={`/auth?resume=${page}`} />
        )
      }
    />
  );
};

DefaultRoute.propTypes = {
  component: PropTypes.func.isRequired,
};

export default DefaultRoute;
